export enum CalcEvent {
    
    COMMAND_COPY_LAST = 'COMMAND_COPY_LAST',
    COMMAND_SELECT_EXPRESSION = 'COMMAND_SELECT_EXPRESSION',
    COMMAND_SET_EXPRESSION = 'COMMAND_SET_EXPRESSION',
    COMMAND_INSERT_EXPRESSION = 'COMMAND_INSERT_EXPRESSION',
    COMMAND_WRAP_EXPRESSION = 'COMMAND_WRAP_EXPRESSION',
    COMMAND_EVALUATE = 'COMMAND_EVALUATE',
    
    COMMAND_SIDEBAR_TAB = 'COMMAND_SIDEBAR_TAB',
    
    COMMAND_UPDATE_PREFS = 'COMMAND_UPDATE_PREFS',
    UPDATED_CALC_PREFS = 'UPDATED_CALC_PREFS',
    
    SCOPE_UPDATE = 'SCOPE_UPDATE'
    
};